export default "__VITE_ASSET__CK6GrF$b__"